import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { HowItWorks } from '../components/HowItWorks';
import { DownloadAppSection } from '../components/DownloadAppSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen" data-id="element-406">
      <HeroSection data-id="element-407" />
      <BenefitsSection data-id="element-408" />
      <HowItWorks data-id="element-409" />
      <DownloadAppSection data-id="element-410" />
      <Footer data-id="element-411" />
    </div>;
}